module.exports = __webpack_public_path__ + "static/media/ki.28e34a88.svg";